// extracted by mini-css-extract-plugin
export default {"AssetsGrid":"Assets_AssetsGrid__0UP8N"};